import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { FieldsService } from 'src/app/services/fields.service';
import { LoadingService } from 'src/app/services/loading.service';
import { MapService } from 'src/app/services/map.service';


@Component({
  selector: 'app-fields-modal',
  templateUrl: './fields-modal.component.html',
  styleUrls: ['./fields-modal.component.scss'],
})
export class FieldsModalComponent  implements OnInit {


  fields: any[] = [];

  fieldSelected: number  = 1;
  constructor(private mapService: MapService,public loadingService: LoadingService, private fieldService: FieldsService,
    private modalCtrl: ModalController,
    public navParams : NavParams
    ) {
    this.fieldSelected = navParams.get('fieldSelected');
    fieldService.getFields().subscribe((resp) => {
      this.fields = resp;
    })
  }

  ngOnInit() {}

  closeMenu() {
    //this.closeEvent.next(false);
  }

  setCenterMap(lat: number, lng: number, id){
    this.fieldSelected = id;
    this.mapService.setCenterMap(lat, lng);
    this.cancel()
  }


  cancel() {
    return this.modalCtrl.dismiss(this.fieldSelected, 'cancel');
  }
  confirm() {
  }
}
